import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, ZipCode } from '../types';

const URL = '/v2/zip-codes';

class ZipCodeService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<ZipCode>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<ZipCode>> {
    return axios.get(URL, config);
  }

  static patch(id: number, data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<ZipCode>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static create(data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<ZipCode>> {
    return axios.post(URL, data, config);
  }
}

export { ZipCodeService };
